<template>
  <div class="container">
    <div class="row statistics">
      <div class="col-md-7 first-div">
        <Statistics />
      </div>
      <div class="col-md-5 second-div">
        <h1 class="text-center">Reset Password</h1>
        <p
          :class="[isApiError ? 'text-danger' : 'text-success']"
          class="mb-0 mt-0"
          v-if="apiResponseMessage"
        >{{ apiResponseMessage }}</p>
        <form method="POST" @submit.prevent="sendNewPassword">
          <p
            class="text-danger mb-0"
            v-if="!$v.repeatPassword.sameAsPassword"
          >Passwords must be identical!</p>
          <p
            class="text-danger"
            v-if="!$v.password.minLength"
          >Password must have at least {{ $v.password.$params.minLength.min }} letters!</p>
          <div class="input-group form-group mt-3">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              type="password"
              class="form-control"
              placeholder="New Password:"
              v-model.trim="$v.password.$model"
              required
            />
          </div>
          <div class="input-group form-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              type="password"
              class="form-control"
              placeholder="Confirm New Password:"
              v-model.trim="$v.repeatPassword.$model"
              required
            />
          </div>
          <button class="btn btn-primary float-right" type="submit" :disabled="$v.$anyError">
            Set Password
            <b-spinner small v-if="isLoading"></b-spinner>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { setNewPassword } from "./../api/services/forgot-password";
export default {
  data() {
    return {
      password: "",
      isLoading: false,
      repeatPassword: "",
      apiResponseMessage: "",
      isApiError: false,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    repeatPassword: {
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    async sendNewPassword() {
      this.isLoading = true;
      this.isApiError = false;
      try {
        let { data, status } = await setNewPassword({
          email: this.$route.query.email,
          password: this.password,
          password_confirmation: this.repeatPassword,
          token: this.$route.query.token,
        });
        if (status === 200) {
          this.apiResponseMessage = data.message;
          setTimeout(() => {
            location.href = "/login";
          }, 2000);
        } else {
          this.apiResponseMessage = data.error;
          this.isApiError = true;
        }
      } catch (error) {
        console.log(error.error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>